import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { PublicFreemiumReportsPage } from '../../../models/PublicFreemiumReports/PublicFreemiumReports';

export const fetchPublicFreemiumReports = createAsyncThunk(
    'publicFreemiumReports/fetchPublicFreemiumReports',
    async (
        params: {
            page: number;
            pageSize: number;
            email?: string;
            sortField?: string;
            isAscending?: boolean;
        },
        dispatch: any
    ) => {
        const axios = dispatch.getState().core.axios;
        const emailQuery = params.email ? `&email=${encodeURIComponent(params.email)}` : '';
        const sortQuery = params.sortField
            ? `&sortField=${encodeURIComponent(params.sortField)}&isAscending=${params.isAscending === true}`
            : '';
        const response = await axios.get(
            `/api/PublicFreemiumReports?page=${params.page}&pageSize=${params.pageSize}${emailQuery}${sortQuery}`
        );

        if (response.status !== 200) {
            createNotification('Could not fetch public Free & Easy reports at the moment.', 'error');
            throw new Error('Failed to fetch public Free & Easy reports');
        }

        return response.data as PublicFreemiumReportsPage;
    }
);
